<template>
  <div class="tw-mt-4">
    <Card
      v-if="showUpgradeMessage"
      :has-body-padding-small="true"
    >
      <template #body>
        <UpgradeToAllAccess
          :benefits-text="benefitsText"
          header-text="Upgrade to All-Access"
        />
      </template>
    </Card>
    <CamsUrlButton
      v-if="!showUpgradeMessage && hasCams && hasCamsUrl"
      class="tw-mb-4"
      :has-cams="hasCams"
      :location="location"
    />
    <ImageViewCardList
      v-if="!showUpgradeMessage && hasCams"
      :images="allCams"
      image-type="cam"
      :is-favorites="isFavorites"
    />
    <NoFavoritesMessage
      v-else-if="!showUpgradeMessage"
      additional-class-names="tw-py-10 lg:tw-py-16"
      :has-cams="hasCams"
      :has-cams-url="hasCamsUrl"
      :is-favorites="isFavorites"
      :location="location"
      view="cams"
      @favorites-added="handleFavoritesAdded"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useUserStore } from '@@/stores/User';

export default {
  name: 'CamViewCardList',

  props: {
    isFavorites: {
      type: Boolean,
      default: false,
    },
    cams: {
      type: Array,
      default: null,
    },
    locations: {
      type: Array,
      default: null,
    },
  },

  emits: ['favorites-added'],

  computed: {
    ...mapState(useUserStore, ['isAllAccess']),

    allCams() {
      if (!this.hasCams) {
        return [];
      }

      return this.cams.map((cam) => {
        const location = this.locations.find((l) => l.id === cam.location_id);
        return { image: cam, location };
      });
    },

    hasCams() {
      return this.cams?.length > 0;
    },

    hasCamsUrl() {
      return !!this.location?.cams_url;
    },

    location() {
      return this.isFavorites ? null : this.locations?.[0];
    },

    showUpgradeMessage() {
      return this.isFavorites && !this.isAllAccess;
    },

    benefitsText() {
      return 'Upgrade to OpenSnow to compare all your favorite webcams to see where the snow is piling up, and gain access to a ton of other great features:';
    },
  },

  methods: {
    handleFavoritesAdded(countFavoritesAdded) {
      this.$emit('favorites-added', countFavoritesAdded);
    },
  },
};
</script>
